import React, { Fragment, useContext } from 'react';
import { Image } from '../../AbstractElements';
import CustomizerContext from '../../_helper/Customizer';
import { Link } from 'react-router-dom';

const SidebarLogo = () => {
  const { toggleSidebar, toggleIcon } = useContext(CustomizerContext);

  return (
    <Fragment>
      <div className="logo-wrapper">
        {/* FARA wordmark — centered, full-width in the expanded sidebar */}
        <Link className="sidebar-brand" to={`${process.env.PUBLIC_URL}/dashboard`}>
          <Image
            attrImage={{
              className: 'img-fluid sidebar-brand-logo',
              src: `${require('../../assets/images/logo/logo.png')}`,
              alt: 'Fara Boutique',
            }}
          />
        </Link>
        <div className="back-btn" onClick={() => toggleSidebar(!toggleIcon)}>
          <i className="fa fa-angle-left"></i>
        </div>
      </div>
    </Fragment>
  );
};

export default SidebarLogo;
